import { Resource } from "../../../common/resource.model";
import { Entidade } from '../entidade/entidade';

export class LayoutCss extends Resource {
    entidade: Entidade;
    nav: string;
    secondary: string;
    header: string;
    btn: string;

    get navColor(): ColorLayout{
        return ColorsLayout[this.nav]();
    }

    get secondaryColor(): ColorLayout{
        return ColorsLayout[this.secondary]();
    }

    get headerColor(): ColorLayout{
        return ColorsLayout[this.header]();
    }

    get btnColor(): ColorLayout{
        return ColorsLayout[this.btn]();
    }
}


export interface ColorLayout {
    nome: string;
    colorBg: string;
    colorText: string;
    colorNav: string;
    colorBtn: string;
    cardColor: string;
}

export class ColorsLayout {
    public static AZUL(): ColorLayout {
        return { nome: 'Azul', colorBg: 'bg-primary', colorText: 'text-primary', colorNav: 'navbar-light', colorBtn: 'btn-primary', cardColor: 'card-primary' };
    }

    public static AMARELO(): ColorLayout {
        return { nome: 'Amarelo', colorBg: 'bg-warning', colorText: 'text-warning', colorNav: 'navbar-light', colorBtn: 'btn-warning', cardColor: 'card-warning' };
    }
    public  static CINZA(): ColorLayout {
        return { nome: 'Cinza', colorBg: 'bg-secondary', colorText: 'text-muted', colorNav: 'navbar-light', colorBtn: 'btn-secondary', cardColor: 'card-secondary' };
    }
    public  static VERDE(): ColorLayout {
        return { nome: 'Verde', colorBg: 'bg-success', colorText: 'text-success', colorNav: 'navbar-light', colorBtn: 'btn-success', cardColor: 'card-success' };
    }
    public  static VERMELHO(): ColorLayout {
        return { nome: 'Vermelho', colorBg: 'bg-danger', colorText: 'text-danger', colorNav: 'navbar-light', colorBtn: 'btn-danger', cardColor: 'card-danger' };
    }
    public  static AZULCLARO(): ColorLayout {
        return { nome: 'Azul Claro', colorBg: 'bg-info', colorText: 'text-info', colorNav: 'navbar-light', colorBtn: 'btn-info', cardColor: 'card-info' };
    }
    public static PRETO(): ColorLayout {
        return { nome: 'Preto', colorBg: 'bg-dark', colorText: 'text-dark', colorNav: 'navbar-light', colorBtn: 'btn-dark', cardColor: 'card-dark' };
    }
    public static BRANCO(): ColorLayout {
        return { nome: 'Branco', colorBg: 'bg-light', colorText: 'text-ligth', colorNav: 'navbar-dark', colorBtn: 'btn-ligth', cardColor: 'card-ligth' };
    }

    public static COLORS(): ColorLayout[] {
        return [
            { nome: 'Azul', colorBg: 'bg-primary', colorText: 'text-primary', colorNav: 'navbar-light', colorBtn: 'btn-primary', cardColor: 'card-primary' },
            { nome: 'Amarelo', colorBg: 'bg-warning', colorText: 'text-warning', colorNav: 'navbar-light', colorBtn: 'btn-warning', cardColor: 'card-warning' },
            { nome: 'Cinza', colorBg: 'bg-secondary', colorText: 'text-muted', colorNav: 'navbar-light', colorBtn: 'btn-secondary', cardColor: 'card-secondary' },
            { nome: 'Verde', colorBg: 'bg-success', colorText: 'text-success', colorNav: 'navbar-light', colorBtn: 'btn-success', cardColor: 'card-success' },
            { nome: 'Vermelho', colorBg: 'bg-danger', colorText: 'text-danger', colorNav: 'navbar-light', colorBtn: 'btn-danger', cardColor: 'card-danger' },
            { nome: 'Azul Claro', colorBg: 'bg-info', colorText: 'text-info', colorNav: 'navbar-light', colorBtn: 'btn-info', cardColor: 'card-info' },
            { nome: 'Preto', colorBg: 'bg-dark', colorText: 'text-dark', colorNav: 'navbar-light', colorBtn: 'btn-dark', cardColor: 'card-dark' },
            { nome: 'Branco', colorBg: 'bg-light', colorText: 'text-ligth', colorNav: 'navbar-dark', colorBtn: 'btn-ligth', cardColor: 'card-ligth' }
        ];
    }
}